/* RESPONSIBLE TEAM: team-inbox-experience */

// Keep in sync with BulkExportConversationTranscriptsWorker::MAX_CONVERSATIONS in the intercom repo
export const MAX_BULK_EXPORT_CONVERSATIONS = 200;
